"use client";

import { Main } from "@/components/Main";
import { ErrorView, type ErrorViewProps } from "@/components/ErrorView";

export default function Error(props: ErrorViewProps) {
    // Outside the dashboard shell, so this page brings its own main landmark (the shell's has one).
    return (
        <Main>
            <ErrorView {...props} />
        </Main>
    );
}
